import React, { Component } from 'react';
import * as HomeComponent from '../Home';
import Corporate from '../Home/Corporate/Corporate';
import Freelance from '../Home/Freelance/Freelance';
import Personal from '../Home/Personal/Personal';


class Home extends Component {
  state = {
    activeView: null, // 'corporate' | 'freelance'
    atBottom: false
  };

  openView = (view) => {
    document.body.style.overflow = 'hidden';
    this.setState({ activeView: view });
  };

  closeView = () => {
    document.body.style.overflow = 'auto';
    this.setState({ activeView: null });
  };

  componentDidMount() {
    // this.handleScrollEvents();. Comments out due to removal of navbar, mobile and web sections

    //Add listener
    // window.addEventListener('load', () => this.updateNavBarWhenScrolled());. Comments out due to removal of navbar
    // window.addEventListener('scroll', () => this.updateNavBarWhenScrolled());. Comments out due to removal of navbar
  }

  handleScrollV2 = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    // Smooth threshold: start hiding arrow a few pixels before exact bottom
    const atBottom = scrollTop + clientHeight >= scrollHeight - 20;

    if (atBottom !== this.state.atBottom) {
      this.setState({ atBottom });
    }
  };

  // Update bold navbar items when user scrolls
  updateNavBarWhenScrolled() {
      const sections = document.querySelectorAll('.section, .sticky_parent');
      const navbar = document.getElementById('navbar');
      const boldTags = navbar.querySelectorAll('b');
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      let lastVisibleIndex = -1;

      sections.forEach((section, index) => {
          if (!boldTags[index]) return;

          const sectionTop = section.offsetTop;
          const sectionBottom = sectionTop + section.offsetHeight;

          // Section is visible if any part of it is in viewport
          if (scrollY + windowHeight > sectionTop + 10) {
              lastVisibleIndex = index;
          }
      });

      boldTags.forEach((tag, i) => {
          if (i <= lastVisibleIndex) {
              tag.style.color = '#FFFFFF';
              tag.style.display = 'block';
          } else {
              tag.style.color = '#000000';
              tag.style.display = 'none';
          }
      });
  }

  // Handle scroll events for sticky sections and navbar updates
  handleScrollEvents() {
      const stickySections = [...document.querySelectorAll('.sticky')];
      const documentSections = document.getElementsByClassName('section');
      const navbar = document.getElementById('navbar');
      const boldTags = navbar.querySelectorAll('b');

      window.addEventListener('scroll', () => {
      stickySections.forEach(section => this.transformHorizontal(section));
      });

      window.addEventListener('resize', () => {
      stickySections.forEach(section => this.transformHorizontal(section));
      });
  }

  // Transform horizontal scroll based on vertical scroll
  transformHorizontal(section) {
    const scrollSection = section.querySelector('.scroll_section');
    const parent = section.parentElement;

    const scrollWidth = scrollSection.scrollWidth;
    const viewportWidth = window.innerWidth;

    // Space at right (adjust as needed: px or rem converted to px)
    const extraSpace = 100; // ~2rem

    // Parent height = horizontal scroll distance + viewport height
    const scrollHeight = (scrollWidth - viewportWidth + extraSpace) + window.innerHeight;
    parent.style.height = `${scrollHeight}px`;

    const offsetTop = parent.offsetTop;
    const scrollY = window.scrollY;

    // Bounds for this section
    const start = offsetTop;
    const end = offsetTop + scrollHeight - window.innerHeight;

    let x = 0;

    if (scrollY < start) {
        // Before section
        x = 0;
    } else if (scrollY > end) {
        // After section → stop at last child minus breathing space
        x = scrollWidth - viewportWidth + extraSpace;
    } else {
        // While inside section
        const progress = (scrollY - start) / (scrollHeight - window.innerHeight);
        x = progress * (scrollWidth - viewportWidth + extraSpace);
    }

    scrollSection.style.transform = `translate3d(${-x}px, 0, 0)`;
  }

  // Check if element is visible in viewport
  isInViewport(elementId) {
      const element = document.getElementById(elementId);
      const rect = element.getBoundingClientRect();
      const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  }

  render() {
    return (
        <div id="root" className="App">
            <main id="main">
            <section id="sec1" className="section d-flex">
                <HomeComponent.Me openView={this.openView} />
            </section>

            {/* Mobile Horizontal Scroll Section */}
                {/* <div className="sticky_parent">
                    <div className="sticky">
                        <div className="scroll_section mx-5">
                            <HomeComponent.WorksMobile />
                        </div>
                    </div>
                </div> */}

            {/* Web Horizontal Scroll Section */}
            {/* <div id="sec2" className="sticky_parent">
                <div className="sticky">
                <div className="scroll_section mx-5">
                    <HomeComponent.WorksWeb />
                </div>
                </div>
            </div> */}

            <section id="sec3" className="section d-flex">
                <HomeComponent.About />
            </section>

            <section className="d-flex div-spacer"></section>

            <section id="sec4" className="section d-flex py-3">
                <HomeComponent.Contact />
            </section>
            </main>
            {/* <Navbar /> Hidden VOLT Navbar */}

            {this.state.activeView && (
            <div className="overlay">
                <div className="popup-content">

                {/* Close button ALWAYS on top */}
                <button className="close-btn" onClick={this.closeView}>×</button>

                {/* Scrollable content only */}
                <div
                    className="popup-inner"
                    onScroll={this.handleScrollV2}
                    ref={this.popupRef}
                >
                    {this.state.activeView === 'corporate' && <Corporate />}
                    {this.state.activeView === 'freelance' && <Freelance />}
                    {this.state.activeView === 'personal' && <Personal />}
                </div>

                {/* Scroll hint */}
                {!this.state.atBottom && (
                    <div className="scroll-hint">↓</div>
                )}

                </div>
            </div>
            )}
        </div>
    );
  }
}


export default Home;